module.exports = __webpack_public_path__ + "static/media/arabia_matig.fd0dd16d.jpg";